import { Component, CustomElement } from "../../core/CustomElement";

// Interfaces.
import Discussion from "../../core/interfaces/Discussion";

// Utilities.
import { validateJsonStringified } from "../../core/utilities";

// Components to use.
import "../loader";
import "../link";

@Component("ccc-discussion-detail", {
  template: require("./discussionDetail.html").default,
  style: require("./discussionDetail.scss").default,
  viewModel: require("./discussionDetailVm"),
  observedAttributes: ["discussion"],
})
export default class CCCDiscussionDetail extends CustomElement {
  private getDiscussion: (discussionId: number) => Promise<Discussion>;

  constructor() {
    super();
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: string | null,
    newValue: string | null
  ): void {
    if (attr === "discussion") {
      const discussion: Discussion = validateJsonStringified(newValue);
      if (discussion) {
        this.discussion = discussion;
      } else {
        this.discussion = null;
      }
    }
  }

  public set discussion(discussion: Discussion) {
    this.viewModel.discussion(discussion);
    if (
      !discussion.insertUser ||
      !discussion.name ||
      !discussion.url ||
      !discussion.countViews ||
      !discussion.countComments ||
      !discussion.lastUser
    ) {
      if (this.getDiscussion) {
        this.getDiscussion(discussion.discussionId).then(
          (discussionFromApi) => {
            this.viewModel.discussion(discussionFromApi);
            this.viewModel.loaded(true);
          }
        );
      }
    } else {
      this.viewModel.loaded(true);
    }
  }

  public onLoad(
    getDiscussion: (discussionId: number) => Promise<Discussion>
  ): void {
    this.getDiscussion = getDiscussion;
  }
}
